export const ROLE = {
  OTHERS: "Others",
  ADMIN: "Administrator",
  TECHNICIAN: "Technician",
  SUPER_INTENDENT: "Superintendent",
  DEVELOPER: "Developer",
  SCHEDULER: "Scheduler",
  HEP_PREPARER: "HEP Preparer",
  HEP_VIEWER: "HEP Viewer"
};

export const ADMIN_PAGE_OPTIONS = {
  ADMIN_PORTAL: "Administrator Portal",
  HEP_PORTAL: "HSE Execution Plan (HEP Portal)"
}